import { render, staticRenderFns } from "./ToothChart.vue?vue&type=template&id=db0c035c&scoped=true&"
import script from "./ToothChart.vue?vue&type=script&lang=js&"
export * from "./ToothChart.vue?vue&type=script&lang=js&"
import style0 from "./ToothChart.vue?vue&type=style&index=0&id=db0c035c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0c035c",
  null
  
)

export default component.exports